/**
 * Piropa: barra fija de "Agregar al carrito" en mobile (PDP).
 * Se muestra cuando el botón de compra principal sale del viewport hacia
 * arriba (IntersectionObserver). El botón real vive fuera del <product-form>
 * (usa el atributo form="..." para disparar el submit), así que el estado
 * disabled/texto (agotado, variante sin stock) se espeja desde el botón
 * original con un MutationObserver — la fuente de verdad es siempre Dawn.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function syncButtonState(sourceButton, stickyButton, stickyLabel) {
    var isDisabled =
      sourceButton.hasAttribute('disabled') || sourceButton.getAttribute('aria-disabled') === 'true';

    stickyButton.disabled = isDisabled;
    if (isDisabled) {
      stickyButton.setAttribute('aria-disabled', 'true');
    } else {
      stickyButton.removeAttribute('aria-disabled');
    }

    var sourceLabel = sourceButton.querySelector('span');
    if (sourceLabel && stickyLabel) {
      stickyLabel.textContent = sourceLabel.textContent;
    }
  }

  function extractCurrentPriceText(priceContainer) {
    if (!priceContainer) return '';
    var priceEl = priceContainer.querySelector('.price');
    var onSale = !!priceEl && priceEl.classList.contains('price--on-sale');
    var selector = onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
    var node = priceContainer.querySelector(selector);
    return node ? node.textContent.trim() : '';
  }

  function initStickyAtc(bar) {
    var sourceButtonId = bar.getAttribute('data-source-button-id');
    var sourceButton = sourceButtonId ? document.getElementById(sourceButtonId) : null;
    if (!sourceButton) return;

    var stickyButton = bar.querySelector('[data-piropa-sticky-atc-button]');
    var stickyLabel = bar.querySelector('[data-piropa-sticky-atc-label]');
    var stickyPrice = bar.querySelector('[data-piropa-sticky-atc-price]');

    syncButtonState(sourceButton, stickyButton, stickyLabel);

    var stateObserver = new MutationObserver(function () {
      syncButtonState(sourceButton, stickyButton, stickyLabel);
    });
    stateObserver.observe(sourceButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    var priceContainerId = bar.id.replace('PiropaStickyAtc-', 'price-');
    var priceContainer = document.getElementById(priceContainerId);
    if (priceContainer && stickyPrice) {
      var priceObserver = new MutationObserver(function () {
        var text = extractCurrentPriceText(priceContainer);
        if (text) stickyPrice.textContent = text;
      });
      priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }

    var mql = window.matchMedia(MOBILE_QUERY);
    var visibilityObserver = null;

    function show() {
      bar.classList.add('piropa-sticky-atc--visible');
      bar.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      bar.classList.remove('piropa-sticky-atc--visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    function handleIntersect(entries) {
      entries.forEach(function (entry) {
        var shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (shouldShow) {
          show();
        } else {
          hide();
        }
      });
    }

    function enableObserver() {
      if (visibilityObserver) return;
      visibilityObserver = new IntersectionObserver(handleIntersect, { threshold: 0 });
      visibilityObserver.observe(sourceButton);
    }

    function disableObserver() {
      if (!visibilityObserver) return;
      visibilityObserver.disconnect();
      visibilityObserver = null;
      hide();
    }

    function handleBreakpointChange(event) {
      if (event.matches) {
        enableObserver();
      } else {
        disableObserver();
      }
    }

    if (mql.matches) enableObserver();
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handleBreakpointChange);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(handleBreakpointChange);
    }
  }

  function init() {
    document.querySelectorAll('[data-piropa-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
